import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X } from 'lucide-react';

export default function SuccessToast({ message, isVisible, onClose, duration = 3000 }) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed top-6 right-6 z-40"
          initial={{ opacity: 0, y: -20, x: 20 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: -20, x: 20 }}
          transition={{ duration: 0.3 }}
        >
          <div className="bg-green-100 border border-green-300 rounded-[10px] px-6 py-4 flex items-center gap-3 shadow-[0px_10px_25px_0px_rgba(0,0,0,0.1)]">
            <Check size={24} className="text-green-600" strokeWidth={2} />
            <p className="text-green-800 font-semibold font-opensans text-sm">
              {message}
            </p>
            <motion.button
              onClick={onClose}
              className="ml-2 text-green-600 hover:text-green-800 transition"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <X size={18} strokeWidth={2} />
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
